<style scoped>
.error-page {
	width: 800px;
	text-align: center;
	margin: 100px auto 0;
	padding: 50px;
	font-size: 18px;
	line-height: 1.5;
	color: #999;
	border: 1px solid #e0e0e0;
	background-color: #fff;
}
</style>

<template>
	<div class="error-page">
		<h2>Oops</h2>
		<p>{{$t('global.common.pageError')}}</p>
	</div>
</template>
<script>
export default {

}
</script>

